module.exports = __webpack_public_path__ + "static/media/Wozz(JAP)_00002.ffd83e8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/debug/Wozz(JAP)_00002.png
// module id = 288
// module chunks = 0